module.exports = __webpack_public_path__ + "omniv2/img/icon-gearstick.241d3273.svg";